var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfoSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#101820}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 4",
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16 31a15 15 0 1115-15 15 15 0 01-15 15zm0-28a13 13 0 1013 13A13 13 0 0016 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15 14h2v9h-2zM16 12a2 2 0 112-2 2 2 0 01-2 2zm0-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoSign);
export default __webpack_public_path__ + "static/media/icon_info_sign.17edf89046c8c79c2dc0b5f43be939a5.svg";
export { ForwardRef as ReactComponent };